export enum ShippingMethod {
  Express = 'EXPRESS',
  Standard = 'STANDARD',
}

export const DEFAULT_SHIPPING_METHOD = ShippingMethod.Standard;
